import * as React from 'react'

import {IEditProfileComponentProps} from "./IEditProfileComponentProps";
import {IEditProfileComponentState} from "./IEditProfileComponentState";
import Loader from 'react-loader-spinner'
import {Button, Image, Input, Modal, Responsive} from 'semantic-ui-react'
import "semantic-ui-css/semantic.min.css";
import 'src/assets/css/editProfileModal.css'
import Backend from "../../api/Backend";
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import * as actions from "../../actions/userAction";
import * as action from "../../actions/toastAction";
import * as sideaction from "../../actions/modalActions";
import MagicDropzone from 'react-magic-dropzone';

class EditProfileComponent extends React.Component<IEditProfileComponentProps, IEditProfileComponentState> {

    constructor(props: IEditProfileComponentProps) {
        super(props)
        this.state = {
            open: false,
            loading: false,
            userID: '',
            name: '',
            changed: false,
            email: '',
            facebook: '',
            instagram: '',
            website: '',
            photo: '',
            photoBlob: '',
            value: "image/jpeg, image/png, .jpg, .jpeg, .png",
        }
    }


    onOpenModal = () => {
        this.props.closeSide()
        this.props.openSettings(!this.props.settings)

  };

  onCloseModal = () => {
    this.setState({ open: false });
  };


	save = () => {
		this.setState({ loading: true })
		console.log('loading true : ', this.state.loading)
		let { userID, name, email, photoBlob, photo, facebook, instagram, website, changed } = this.state
		this.props.updateUser({ userID, name, photo, email, photoBlob, facebook, instagram, website, changed },
			() => {
				this.setState({ loading: false })
				console.log('loading false : ', this.state.loading)
				this.onCloseModal()
				this.props.showToast("succès de l'opération", true, () => { })
			})

	}

	componentWillMount() {
		this.setState({
			userID: this.props.currentUser ? this.props.currentUser.userID : '',
			name: this.props.currentUser ? this.props.currentUser.name : '',
			email: this.props.currentUser ? this.props.currentUser.email : '',
			photo: this.props.currentUser ? this.props.currentUser.photo : '',
			facebook: this.props.currentUser ? this.props.currentUser.facebook : '',
			instagram: this.props.currentUser ? this.props.currentUser.instagram : ''
		})
	}
	onDrop = (accepted, rejected, links) => {
		this.setState({
			changed: true,
			photo: accepted[0].preview,
			photoBlob: accepted[0]
		})
	}

  public render() {

	    console.log(this.props.settings)
    return (
      <div>


                <Modal
                    size={'fullscreen'}
                    trigger={
                        <div>
                            <div className="menu_item" onClick={this.onOpenModal}> Settings</div>

                        </div>
                    }
                    open={this.props.settings}

                    /* closeOnEscape={false}
                     closeOnDimmerClick={false}
                     */
                    onClose={this.onOpenModal}
                    centered={false}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin : '2%',
                        marginBottom : '5%'
                    }}
                    //dimmer='blurring'
                >
                    <Modal.Content style={{
                        zIndex: 999
                    }}>

                        <Responsive>
                            <div
                                className="show-image"
                            >
                                <img
                                    src={this.state.photo}
                                    style={{
                                        width: '90%',
                                        maxWidth : '250px' ,
                                        height: '250px',
                                        borderRadius: '50%'
                                    }}
                                    className='profile_img ui image'
                                />

							<MagicDropzone
								accept={this.state.value}
								onDrop={this.onDrop}
								multiple={false}
							>

								<input
									className="update"
									type="button"
									value="Change"
									onClick={(e) => e.preventDefault()}
									style={{
										width: "100%"
									}}
								/>
							</MagicDropzone>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								width: '100%',
								marginBottom: '3%'
							}}
						>
							<Input
								icon='user circle'
								iconPosition='left'
								style={{
									marginBottom: '1%'
								}}
								placeholder="Nom"
								value={this.state.name}
								onChange={e => this.setState({ name: e.target.value })}
							/>
							<Input
								icon='mail'
								iconPosition='left'
								style={{
									marginBottom: '1%'
								}}
								placeholder="Email"
								value={this.state.email}
								onChange={(e) => { this.setState({ email: e.target.value }) }}
							/>
							<Input
								icon='facebook'
								iconPosition='left'
								style={{
									marginBottom: '1%'
								}}
								placeholder="Facebook"
								value={this.state.facebook}
								onChange={(e) => { this.setState({ facebook: e.target.value }) }}
							/>
							<Input
								icon='instagram'
								iconPosition='left'
								style={{
									marginBottom: '1%'
								}}
								placeholder="Instagram"
								value={this.state.instagram}
								onChange={(e) => { this.setState({ instagram: e.target.value }) }}
							/>
							<Input
								icon='at'
								iconPosition='left'
								placeholder="Website"
								value={this.state.website}
								onChange={(e) => { this.setState({ website: e.target.value }) }}
							/>
						</div>
						{
							this.state.loading ?
								<Loader type="Oval" color="#f34c71" height={20} width={20} /> :
								<Button
									color='black'
									onClick={this.save}
									style={{
										width: '100%',
										height: 50,
										cursor: 'pointer'
									}}
								>
									Enregister
            </Button>
						}
                        </Responsive>
					</Modal.Content>
				</Modal>
			</div>

		);
	}

}

const mapDispatchToProps = (dispatch: any, ownProps: IEditProfileComponentProps) => {
	return {
		updateUser: (user, cb) => dispatch(actions.update(user, cb)),
		showToast: (title, show, cb) => dispatch(action.toast(title, show, cb)),
		closeSide: () => dispatch(sideaction.sideBar(false)),
        openSettings: (settings) => dispatch(sideaction.settings(settings))
    }

}


function mapsStateToProps(state) {
	return {
		// photo: state.auth.currentUser.photo + '?width=500',
		// email: state.auth.currentUser.email,
		// name: state.auth.currentUser.name,
		// userID: state.auth.currentUser.uid,
		// facebook: state.auth.currentUser.facebook,
		// instagram: state.auth.currentUser.instagram,
		// website: state.auth.currentUser.website,
		currentUser: state.auth.currentUser ,
        settings : state.modal.settings
	};
}


export default connect(mapsStateToProps, mapDispatchToProps)(withRouter(EditProfileComponent))



// WEBPACK FOOTER //
// ./src/components/editProfileComponent/EditProfileComponent.tsx